// extracted by mini-css-extract-plugin
export var Link = "SubMenu-module--Link--3x1-8";